// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1sNRZ","content":"LoadingAlert_content__1zeiF"};